import Layout from '../components/project/Layout'
import SimpleNotesPanel from '../components/notes/SimpleNotesPanel'
import WorkspaceHeaderConsolidated from '../components/workspace/WorkspaceHeaderConsolidated'
import { PageErrorBoundary } from '../components/ErrorBoundary'
import { useAuthStore } from '../stores/auth-store'
import { useUIStore } from '../stores/ui-store'
import { trpc } from '../lib/trpc'
import { useNavigate } from 'react-router'
import { Loader2 } from 'lucide-react'

export default function Notes() {
  const navigate = useNavigate()
  const { isAuthenticated } = useAuthStore()
  const { 
    openTaskCreationModal, 
    triggerNoteCreation,
    toggleFocusMode
  } = useUIStore()
  
  const { data: workspaces = [] } = trpc.workspace.list.useQuery()
  const activeWorkspace = workspaces[0]
  
  const { data: panels = [] } = trpc.panel.list.useQuery(
    { workspaceId: activeWorkspace?.id ?? '' },
    { 
      enabled: !!activeWorkspace?.id,
      staleTime: 60000,
    }
  )
  
  // Redirect if not authenticated
  if (!isAuthenticated) {
    return null
  }
  
  if (!activeWorkspace) {
    return (
      <Layout>
        <div className="flex items-center justify-center h-full">
          <div className="text-center">
            <Loader2 className="w-8 h-8 animate-spin mx-auto mb-4 text-blue-600" />
            <p className="text-gray-600">Loading notes...</p>
          </div>
        </div>
      </Layout>
    )
  }
  
  const handleNavigate = (path: string) => {
    navigate(path)
  }

  const handleCreatePanel = (type: string) => {
    if (!activeWorkspace) return
    
    if (type === 'NOTE') {
      triggerNoteCreation()
      return
    }
    
    if (type === 'TASK') {
      openTaskCreationModal({})
      return
    }
  }

  const handleAction = (action: string) => {
    switch (action) {
      case 'logout':
        const authStore = useAuthStore.getState()
        authStore.logout()
        navigate('/login')
        break
        
      case 'focus-mode':
        toggleFocusMode()
        break
        
      default:
        break
    }
  }

  return (
    <Layout>
      <div className="flex flex-col min-h-full w-full bg-transparent">
        <WorkspaceHeaderConsolidated
          workspaceId={activeWorkspace.id}
          panels={panels}
          onNavigate={handleNavigate}
          onCreatePanel={handleCreatePanel}
          onAction={handleAction}
        />
        
        <div className="flex-1">
          <PageErrorBoundary>
            <SimpleNotesPanel workspaceId={activeWorkspace.id} />
          </PageErrorBoundary>
        </div>
      </div>
    </Layout>
  )
}